import { Spin } from "antd";

export default function Progress() {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ height: "100vh" }}
    >
      <Spin size="large"></Spin>
    </div>
  );
}
